<template>
  <div>
    <div class="px-5 lg:px-0">
      <div class="mt-6 pt-5 bg-white rounded-lg shadow-ts1 w-[99%] md:mx-auto">
        <div class="w-full pb-4 border-b border-gray-400 border-solid">
          <h2 class="ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 text-blue font-display font-bold text-xl leading-none">{{ $t('overview').tTitle() }}</h2>
        </div>

        <div class="w-auto mt-6 px-6 md:px-10 relative">
          <Carousel navPosition="center" :movementSize="250">

            <div class="flex w-full gap-4 pb-10 overflow-x-scroll noUserSelect no-scrollbar" id="contentContainer">
              <div
                class="w-[250px] h-[180px] bg-blue bg-opacity-15 rounded-lg hover:bg-opacity-30 transition-all duration-300 ease-in-out shrink-0">
                <div class="py-6 px-5">
                  <img src="../../assets/img/balance.svg" class="h-[3.75rem] mb-5" />
                  <p class="text-gray-900 font-medium text-sm leading-6">{{ $t('balance').tTitle() }}</p>
                  <p class="text-blue font-bold text-[32px]">{{ $formatMoney(IB.balance) }}</p>
                </div>
              </div>
              <div class="w-[250px] h-[180px] bg-blue bg-opacity-15 rounded-lg hover:bg-opacity-30 transition-all duration-300 ease-in-out shrink-0">
                <div class="py-6 px-5">
                  <img src="../../assets/img/total-earned.svg" class="h-[3.75rem] mb-5" />
                  <p class="text-gray-900 font-medium text-sm leading-6">{{ $t('total_earned').tTitle() }}</p>
                  <p class="text-blue font-bold text-[32px]">{{ $formatMoney(IB.total_earned) }}</p>
                </div>
              </div>
              <div class="w-[250px] h-[180px] bg-blue bg-opacity-15 rounded-lg hover:bg-opacity-30 transition-all duration-300 ease-in-out shrink-0">
                <div class="py-6 px-5">
                  <img src="../../assets/img/total-paid.svg" class="h-[3.75rem] mb-5" />
                  <p class="text-gray-900 font-medium text-sm leading-6">{{ $t('total_paid').tTitle() }}</p>
                  <p class="text-blue font-bold text-[32px]">{{ $formatMoney(IB.total_paid) }}</p>
                </div>
              </div>
              <div class="w-[250px] h-[180px] bg-blue bg-opacity-15 rounded-lg hover:bg-opacity-30 transition-all duration-300 ease-in-out shrink-0">
                <div class="py-6 px-5">
                  <img src="../../assets/img/total-clients.svg" class="h-[3.75rem] mb-5" />
                  <p class="text-gray-900 font-medium text-sm leading-6">{{ $t('total_clients').tTitle() }}</p>
                  <p class="text-blue font-bold text-[32px]">{{ IB.total_clients }}</p>
                </div>
              </div>
              <div v-if="User.IB.total_deposits" class="w-[250px] h-[180px] bg-blue bg-opacity-15 rounded-lg hover:bg-opacity-30 transition-all duration-300 ease-in-out shrink-0">
                <div class="py-6 px-5">
                  <img src="../../assets/img/total-deposits.svg" class="h-[3.75rem] mb-5" />
                  <div class="flex w-full justify-between">
                    <p class="text-gray-900 font-medium text-sm leading-6">{{ $t('total_deposits').tTitle() }}</p>
                    <div v-if="IB.total_deposits.hasOwnProperty('EUR')" class="flex items-center">
                      <select
                        v-model="selectedDepositCurrency"
                        name="currency"
                        class="h-5 w-[50px] relative z-[1] px-1.5 bg-none bg-transparent text-gray-900 border-0 p-0 rounded-md text-sm font-bold appearance-none focus:outline-none focus:ring-0 [color-scheme:light]"
                      >
                        <option>USD</option>
                        <option>EUR</option>
                      </select>
                      <div class="select-arrow relative z-0 -ml-2.5">
                        <img src="../../assets/img/partners-arrow-previous.svg" width="13" class="-rotate-90 h-[13px]" />
                      </div>
                    </div>
                  </div>

                  <p class="text-blue font-bold text-[32px] ltr:mr-4 rtl:ml-4">
                    {{ $formatMoney(IB.total_deposits[selectedDepositCurrency], currencies[selectedDepositCurrency].symbol) }}
                  </p>
                  <!-- <VueSlickCarousel :dots="false" :infinite="true" :slidesToShow="1" :speed="500">
                    <p v-for="(value, currency) in IB.total_deposits" :key="currency"
                      class="text-blue font-bold text-4xl ltr:mr-4 rtl:ml-4">
                      {{ currencies[currency].symbol }}{{ value }}
                    </p>
                  </VueSlickCarousel> -->
                </div>
              </div>
              <div
                v-if="User.IB.total_withdrawals"
                class="w-[250px] h-[180px] bg-blue bg-opacity-15 rounded-lg hover:bg-opacity-30 transition-all duration-300 ease-in-out shrink-0"
              >
                <div class="py-6 px-5">
                  <img src="../../assets/img/total-withdrawals.svg" class="h-[3.75rem] mb-5" />
                  <div class="flex w-full justify-between">
                    <p class="text-gray-900 font-medium text-sm leading-6">{{ $t('total_withdrawals').tTitle() }}</p>
                    <div v-if="IB.total_withdrawals.hasOwnProperty('EUR')" class="flex items-center">
                      <select
                        v-model="selectedWithdrawalCurrency"
                        name="currency"
                        class="h-5 w-[50px] relative z-[1] px-1.5 bg-none bg-transparent text-gray-900 border-0 p-0 rounded-md text-sm font-bold appearance-none focus:outline-none focus:ring-0 [color-scheme:light]"
                      >
                        <option>USD</option>
                        <option>EUR</option>
                      </select>
                      <div class="select-arrow relative z-0 -ml-2.5">
                        <img src="../../assets/img/partners-arrow-previous.svg" width="13" class="-rotate-90 h-[13px]" />
                      </div>
                    </div>
                  </div>
                  <p class="text-blue font-bold text-[32px] ltr:mr-4 rtl:ml-4">
                    <!-- {{ currencies[selectedWithdrawalCurrency].symbol }} -->
                    {{ $formatMoney(IB.total_withdrawals[selectedWithdrawalCurrency], currencies[selectedWithdrawalCurrency].symbol) }}
                  </p>
                </div>
              </div>
              <div class="w-[250px] h-[180px] bg-blue bg-opacity-15 rounded-lg hover:bg-opacity-30 transition-all duration-300 ease-in-out shrink-0">
                <div class="py-6 px-5">
                  <img src="../../assets/img/total-sub-ibs.svg" class="h-[3.75rem] mb-5" />
                  <p class="text-gray-900 font-medium text-sm leading-6">{{ $t('total_sub_ibs').tTitle() }}</p>
                  <p class="text-blue font-bold text-[32px]">{{ IB.total_sub_ib }}</p>
                </div>
              </div>
            </div>
          </Carousel>
        </div>
        <div class="mb-4 flex items-center justify-between ltr:px-4 rtl:px-5 ltr:md:px-8 rtl:md:px-8">
          <h2 class="text-blue font-display font-bold text-lg leading-none">{{ $t('referal_links').tTitle() }}</h2>
          <LanguageMarketing @language-selected="handleLanguageSelection"></LanguageMarketing>
        </div>
        <div class="w-auto mx-5 md:mx-8 mb-11 md:mb-0 pb-11 relative">
          <div class="flex w-full gap-4 pb-4 overflow-x-auto no-scrollbar" ref="trackingCarousel" id="trackingCarouselContainer">
            <div v-for="(value, key) in trackingLinks" :key="key"
              class="transition-all duration-300 ease-in-out shrink-0">
              <p class="text-gray-900 text-base pb-1.5">{{ $t(`${key}`).tTitle() }}</p>
              <div class="flex maxLg:flex-col gap-2 maxLg:gap-5 w-[423px] maxLg:w-[330px]">
                <div
                  class="grow px-5 py-3 text-[12px] leading-6 bg-[#F0F0F4] rounded-md font-semibold text-gray-900 break-all md:mb-0 w-4/5 maxLg:w-full max-h-[48px] overflow-auto"
                >
                  {{ trackURL + value }}
                </div>
                <Button mode="secondary" @click="copyTrackingLink(trackURL + value)" customClasses="!w-1/5 maxLg:!w-1/3">
                  {{ $t('copy') }}
                </Button>
              </div>
            </div>
          </div>

          <div v-if="isScrollable" class="absolute flex gap-1.5">
            <div @click="scrollLeft('trackingCarouselContainer', 300)" class="cursor-pointer">
              <img src="../../assets/img/arrow-previous.svg" class="h-6 w-6" />
            </div>
            <div @click="scrollRight('trackingCarouselContainer', 300)" class="cursor-pointer">
              <img src="../../assets/img/arrow-next.svg" class="h-6 w-6" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-11 mx-5 lg:mx-0">
      <ButtonGroup mode="underline" :options="['clients', 'subibs']" :titles="['clients', 'sub_ibs']" :selectedOption="selectedTab" @click="opt => (selectedTab = opt)" />
      <div class="mt-8 pb-14 pt-5 bg-white rounded-lg shadow-ts1 mb-20 w-[99%] md:mx-2">
        <div v-if="selectedTab == 'clients'">
          <div class="w-full flex justify-between items-center pb-4 px-7 border-b border-gray-400 border-solid">
            <h2 class="text-blue font-display font-bold text-xl leading-none text-center">{{ $t('clients').tTitle() }}</h2>
            <button @click="exportClientDataCSV" class="appearance-none py-3 text-base rounded-md text-white bg-blue w-24 text-center font-bold">
              {{ $t('export').tTitle() }}
            </button>
          </div>

          <clients :isClientTab="isClientTabSelected" ref="ClientData"></clients>
        </div>

        <div v-if="selectedTab == 'subibs'">
          <div class="w-full flex justify-between items-center pb-4 px-7 border-b border-gray-400 border-solid">
            <h2 class="text-blue font-display font-bold text-xl leading-none">{{ $t('sub_ibs').tTitle() }}</h2>
            <button @click="exportSubIbDataCSV" class="appearance-none py-3 text-base rounded-md text-white bg-blue w-24 text-center font-bold">
              {{ $t('export').tTitle() }}
            </button>
          </div>
          <sub-i-bs ref="SubIbData"></sub-i-bs>
        </div>

        <div v-if="selectedTab == 'cpa'">
          <div class="w-full pb-4 border-b border-gray-400 border-solid">
            <h2 class="ltr:pl-5 ltr:md:pl-8 rtl:pr-5 rtl:md:pr-8 text-blue font-display font-bold text-xl leading-none">
              {{ $t('cpa').tTitle() }}
            </h2>
          </div>
        </div>
      </div>
    </div>

    <logo-loader v-if="logoLoaderActive && ongoingCalls > 0"></logo-loader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import { service } from '../../main.js'
import config from '../../config'
// import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import Clients from './Clients.vue'
import SubIBs from './SubIBs.vue'
import LanguageMarketing from '@/components/LanguageMarketing.vue'
import api from '@/api/index.js'
import LogoLoader from '@/components/LogoLoader.vue'
import Button from '@/components/reusableComponents/Button.vue'
import Carousel from '@/components/reusableComponents/Carousel.vue'
import ButtonGroup from '@/components/reusableComponents/ButtonGroup.vue'

export default {
  components: {
    // VueSlickCarousel,
    Clients,
    SubIBs,
    LanguageMarketing,
    LogoLoader,
    Carousel,
    ButtonGroup,
    Button,
  },
  data() {
    return {
      trackURL: config.URL.track,
      trackingLinks: '',
      currencies: config.currencies,
      selectedTab: 'clients',
      carouselSettings: {
        arrows: false,
        dots: true,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 1.3,
        speed: 500,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      trackingCarouselSettings: {
        dots: false,
        infinite: false,
        slidesToShow: 3.4,
        speed: 500,
        responsive: [
          {
            breakpoint: 1210,
            settings: {
              slidesToShow: 1.8,
            },
          },
          {
            breakpoint: 1047,
            settings: {
              slidesToShow: 1.2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.1,
            },
          },
        ],
      },
      isScrollable: false,
      referralLinksLanguage: '',
      selectedDepositCurrency: 'USD',
      selectedWithdrawalCurrency: 'USD',
    }
  },
  watch: {
    'detailsModal.modalState'(value) {
      if (value === true) {
        this.disableScroll()
      } else {
        this.enableScroll()
      }
    },
    trackingLinks: {
      handler() {
        this.$nextTick(() => {
          this.checkScrollable()
        })
      },
      immediate: true,
    },
    Language(val) {
      this.referralLinksLanguage = val
      this.addHomeAndBonusLinks()
    },
    referralLinksLanguage: {
      handler() {
        this.$nextTick(() => {
          this.addHomeAndBonusLinks()
        })
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      IB: 'user/IB',
      ongoingCalls: 'logoLoader/ongoingCalls',
      logoLoaderActive: 'logoLoader/active',
    }),
    isClientTabSelected() {
      return this.selectedTab === 'clients'
    },
  },
  mounted() {
    this.dragContainer('#contentContainer')
    // get IB overview info
    // if (!this.User?.IB || !Object.keys(this.User.IB).length) {
    // this['logoLoader/set'](true)
    api.GetUserIB().then(UserIB => {
      this['user/setIB'](UserIB)
      // this['logoLoader/set'](false)
      this.addHomeAndBonusLinks()
    })
    // .catch(() => {
    // this['logoLoader/set'](false)
    // })
    // } else {
    //   this.addHomeAndBonusLinks()
    // }

    this.$nextTick(() => {
      this.checkScrollable()
      window.addEventListener('resize', this.checkScrollable)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScrollable)
  },
  methods: {
    copyTrackingLink(link) {
      navigator.clipboard.writeText(link)
      this.$toasted.success(this.$t('copied'))
    },
    scrollLeft(containerId, amount) {
      document.getElementById(containerId).scrollLeft -= amount
    },
    scrollRight(containerId, amount) {
      document.getElementById(containerId).scrollLeft += amount
    },
    /**
     * Function to add the home and bonus link to the trackingLinks array.
     */
    addHomeAndBonusLinks() {
      let langParam = this.referralLinksLanguage !== 'en' ? `&lang=${this.referralLinksLanguage}` : ''
      let entries = this.IB?.tracking_links ? Object.entries(this.IB?.tracking_links) : []
      // Make sure entries are not empty before accessing them
      if (entries.length > 0) {
        // get tracking code from User.
        let trackingCode = entries[0][1]
        let links = {
          registration_link: trackingCode + '&term=register' + langParam,
          website_home_page: trackingCode + '&term=home' + langParam,
          bonus_page: trackingCode + '&term=bonus' + langParam,
          pamm_page: trackingCode + '&term=pamm' + langParam,
        }
        this.trackingLinks = links
      }
    },
    subIBID(value) {
      this.detailsModal.IBID = value.subIBID
      this.detailsModal.modalState = value.modalState
    },
    disableScroll() {
      document.querySelector('body').classList.add('overflow-hidden')
    },
    enableScroll() {
      document.querySelector('body').classList.remove('overflow-hidden')
    },
    exportClientDataCSV() {
      this.$refs.ClientData.$emit('export-csv')
    },
    exportSubIbDataCSV() {
      this.$refs.SubIbData.$emit('export-csv')
    },
    checkScrollable() {
      this.$nextTick(() => {
        const container = this.$refs.trackingCarousel
        if (container) {
          this.isScrollable = container.scrollWidth > container.clientWidth
        }
      })
    },
    handleLanguageSelection(selectedLanguageCode) {
      this.referralLinksLanguage = selectedLanguageCode
    },

    ...mapActions(['logoLoader/set', 'user/setIB']),
  },
}
</script>
<style lang="css">
#trackingCarouselContainer::-webkit-scrollbar {
  display: none;
}

[dir='ltr'] #overviewCarousel .slick-dots {
  text-align: left;
}

[dir='rtl'] #overviewCarousel .slick-dots {
  text-align: right;
}

#trackingCarouselContainer {
  scroll-behavior: smooth;
}
</style>
